import React from 'react';
import { UserBall } from '../user';
import { useLiv } from '../../context/liv';

const LiviaSidebarBottom = () => {
  const { user } = useLiv();
  if (!user) return null;
  const initials = `${user.first_name?.charAt(0) ?? ''}${user.last_name?.charAt(0) ?? ''}`;
  return (
    <>
      <UserBall user={initials.toUpperCase()} />
      <div>
        <p className="text-sm">{user.first_name.toUpperCase()}</p>
        <p className="text-sm">{user.last_name.toUpperCase()}</p>
      </div>
    </>
  );
};

export { LiviaSidebarBottom };
